export enum FormTabNames {
    MAIN_FORM = '1',
    REQUEST_FOR_HELP = '2',
    TABLE_OF_CONTENT = '3',
}
